import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { error, debugError } from "../index";
import { langMap, localLangMap } from "../../const/lang";
import { VERSION } from "../../const";
import { i18nMapping } from "../../services";
import { g } from "../../const/globalThis";
export function formatMessage(message, variables) {
    if (variables && Object.keys(variables).length > 0) {
        var parsedMessage = message;
        Object.keys(variables).forEach(function(k) {
            var reg = new RegExp("{".concat(k, "}"), "g");
            // v 为 string | number , 但是有 value 是 null / undefined 的风险
            var value = typeof variables[k] === "object" || typeof variables[k] === "undefined" ? "" : variables[k].toString();
            // 防止不可见字符出现嵌套,当参数中出现时支持替换回标准字符
            parsedMessage = parsedMessage.replace(reg, i18nMapping.getOriginalCopy(value));
        });
        return parsedMessage;
    }
    return message;
}
export var StringFormat = /*#__PURE__*/ function() {
    "use strict";
    function StringFormat(param) {
        var locale = param.locale, lang = param.lang, packageName = param.packageName, $i18n = param.$i18n;
        _class_call_check(this, StringFormat);
        _define_property(this, "locale", void 0);
        _define_property(this, "lang", void 0);
        _define_property(this, "packageName", void 0);
        _define_property(this, "$i18n", void 0);
        _define_property(this, "version", VERSION);
        this.locale = locale;
        this.lang = lang;
        this.$i18n = $i18n;
        this.packageName = packageName;
    }
    _create_class(StringFormat, [
        {
            key: "format2",
            value: function format2(des, variables, options) {
                var _this = this;
                var _options;
                var lang = (_options = options) === null || _options === void 0 ? void 0 : _options.lang;
                var formattedMessage = "";
                var usedLang = lang;
                var isMatched = false;
                var defaultMessage = des.defaultMessage || "";
                try {
                    var _this_locale_lang, _langMap_lang;
                    var message = ((_this_locale_lang = this.locale[lang]) === null || _this_locale_lang === void 0 ? void 0 : _this_locale_lang[des.id]) || "";
                    if (message) {
                        isMatched = true;
                    }
                    // 根据相识语种查找
                    if (!message && ((_langMap_lang = langMap[lang]) === null || _langMap_lang === void 0 ? void 0 : _langMap_lang.l)) {
                        langMap[lang].l.find(function(_lang) {
                            var _this_locale__lang;
                            if ((_this_locale__lang = _this.locale[_lang]) === null || _this_locale__lang === void 0 ? void 0 : _this_locale__lang[des.id]) {
                                var _this_locale__lang1;
                                message = ((_this_locale__lang1 = _this.locale[_lang]) === null || _this_locale__lang1 === void 0 ? void 0 : _this_locale__lang1[des.id]) || "";
                                // eslint-disable-next-line no-return-assign
                                return usedLang = _lang;
                            }
                            return false;
                        });
                    }
                    // 如不在支持范围，进行本地化语种的查找
                    if (!message && !langMap[lang]) {
                        var localLang = localLangMap[lang.split("-")[0]];
                        if (localLang) {
                            var _this_locale_localLang;
                            if ((_this_locale_localLang = this.locale[localLang]) === null || _this_locale_localLang === void 0 ? void 0 : _this_locale_localLang[des.id]) {
                                var _this_locale_localLang1;
                                message = ((_this_locale_localLang1 = this.locale[localLang]) === null || _this_locale_localLang1 === void 0 ? void 0 : _this_locale_localLang1[des.id]) || "";
                                usedLang = localLang; // notice it not match the type
                            }
                        }
                    }
                    // 根据语种寻找 fallback的语种的翻译
                    if (!message && g.__PANDA.langList) {
                        g.__PANDA.langList.find(function(_lang) {
                            var _this_locale__lang;
                            if ((_this_locale__lang = _this.locale[_lang]) === null || _this_locale__lang === void 0 ? void 0 : _this_locale__lang[des.id]) {
                                var _this_locale__lang1;
                                message = ((_this_locale__lang1 = _this.locale[_lang]) === null || _this_locale__lang1 === void 0 ? void 0 : _this_locale__lang1[des.id]) || "";
                                // eslint-disable-next-line no-return-assign
                                return usedLang = _lang;
                            }
                            return false;
                        });
                    }
                    // 需要确保使用正确的message，没语言包使用dm
                    message = message || defaultMessage;
                    formattedMessage = formatMessage(message, variables);
                } catch (e) {
                    var errorMessage = typeof e === "string" ? e : "Unknown error";
                    error("".concat(des.id, " for ").concat(lang, " failed: \n").concat(errorMessage));
                    debugError(e);
                }
                return {
                    message: formattedMessage || defaultMessage || des.id || "",
                    usedLang: usedLang,
                    isMatched: isMatched
                };
            }
        },
        {
            // 为了兼容老版本确保返回一致性
            key: "format",
            value: function format(des, variables, options) {
                return this.format2(des, variables, options).message;
            }
        },
        {
            key: "setLocale",
            value: function setLocale(locale) {
                this.locale = locale;
            }
        }
    ]);
    return StringFormat;
}();
